import { render, staticRenderFns } from "./ClientSummary.vue?vue&type=template&id=61eabf27&scoped=true"
import script from "./ClientSummary.vue?vue&type=script&lang=js"
export * from "./ClientSummary.vue?vue&type=script&lang=js"
import style0 from "./ClientSummary.vue?vue&type=style&index=0&id=61eabf27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eabf27",
  null
  
)

export default component.exports